// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.servicesCardDiv {
  border: solid 2px black;
  border-radius: 20px;
  background-color: tomato;
  padding: 10px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/servicesCard.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".servicesCardDiv {\n  border: solid 2px black;\n  border-radius: 20px;\n  background-color: tomato;\n  padding: 10px;\n  display:flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
